import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "flex items-center space-x-2 font-medium text-gray-800" }
const _hoisted_4 = {
  key: 0,
  class: "flex space-x-1"
}
const _hoisted_5 = { class: "sr-only" }
const _hoisted_6 = { class: "sr-only" }
const _hoisted_7 = { class: "sr-only" }

import { PropType } from 'vue';
import { SpamNumberModel, Permission } from '@/types';
import { applyPhoneMask } from '@/utils/number';
import { PencilAltIcon, CheckCircleIcon, XCircleIcon } from '@heroicons/vue/outline';


export default /*@__PURE__*/_defineComponent({
  __name: 'SpamNumberListItem',
  props: {
    modelValue: {
        type: Object as PropType<SpamNumberModel>,
        required: true,
    },
},
  emits: ['activate', 'inactivate'],
  setup(__props, { emit: __emit }) {



const emit = __emit;
const handleActivateClick = () => emit('activate', __props.modelValue);
const handleInactivateClick = () => emit('inactivate', __props.modelValue);

return (_ctx: any,_cache: any) => {
  const _component_UiIsActiveBadge = _resolveComponent("UiIsActiveBadge")!
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _component_UiAuditInfo = _resolveComponent("UiAuditInfo")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_component_UiPanel, { class: "space-y-2 hover:bg-white" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$can(_unref(Permission).VIEW_SPAM_NUMBER) ? 'RouterLink' : 'span'), {
              to: {
                            name: 'ViewSpamNumberById',
                            params: {
                                id: __props.modelValue.id,
                            },
                        },
              class: "text-md text-primary truncate"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(applyPhoneMask)(__props.modelValue.number)), 1)
              ]),
              _: 1
            }, 8, ["to"])),
            _createVNode(_component_UiIsActiveBadge, {
              "model-value": __props.modelValue,
              class: "text-xs"
            }, null, 8, ["model-value"])
          ])
        ]),
        (_ctx.$can(_unref(Permission).EDIT_SPAM_NUMBER))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (__props.modelValue.active)
                ? _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                    key: 0,
                    variant: "danger",
                    onClick: handleInactivateClick
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('core.actions.Inactivate')), 1),
                      _createVNode(_unref(XCircleIcon), {
                        class: "h-6 w-6",
                        "aria-hidden": "true"
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_tippy, _ctx.$t('core.actions.Inactivate')]
                  ])
                : _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                    key: 1,
                    variant: "success",
                    onClick: handleActivateClick
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('core.actions.Activate')), 1),
                      _createVNode(_unref(CheckCircleIcon), {
                        class: "h-6 w-6",
                        "aria-hidden": "true"
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_tippy, _ctx.$t('core.actions.Activate')]
                  ]),
              _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                variant: "primary",
                to: {
                        name: 'EditSpamNumberById',
                        params: {
                            id: __props.modelValue.id,
                        },
                    }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('core.actions.Edit')), 1),
                  _createVNode(_unref(PencilAltIcon), {
                    class: "h-6 w-6",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_tippy, _ctx.$t('core.actions.Edit')]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_UiAuditInfo, {
        "model-value": __props.modelValue,
        class: "justify-end"
      }, null, 8, ["model-value"])
    ]),
    _: 1
  }))
}
}

})